export const userAdmin3 = {
  sidebar: {
    logo: "Bespire",
    providerName: "Beauty Studio Bella",
    menu: {
      dashboard: "Dashboard",
      booking: "Book Appointment",
      services: "Services",
      workshops: "Workshops",
      digitalContent: "Digital Content",
      memberships: "My Memberships",
      messages: "Messages",
      loyalty: "Loyalty Rewards",
      progress: "My Progress",
      settings: "Settings",
    },
  },
  header: {
    notifications: "Notifications",
    profile: "Profile",
    pages: {
      dashboard: {
        title: "Dashboard",
        description: "Your bookings, memberships and upcoming events",
      },
      booking: {
        title: "Book Appointment",
        description: "Book an appointment with the provider",
      },
      services: {
        title: "Services",
        description: "Browse and purchase available services",
      },
      workshops: {
        title: "Workshops",
        description: "Upcoming workshops and trainings",
      },
      digitalContent: {
        title: "Digital Content",
        description: "E-books, video courses and other content",
      },
      memberships: {
        title: "My Memberships",
        description: "Manage your active memberships and subscriptions",
      },
      messages: {
        title: "Messages",
        description: "Communication with the provider",
      },
      loyalty: {
        title: "Loyalty Rewards",
        description: "Your loyalty points and rewards",
      },
      settings: {
        title: "Settings",
        description: "Profile and notification settings",
      },
      progress: {
        title: "My Progress",
        description: "Track your progress and reach new goals",
      },
    },
  },
  dashboard: {
    welcome: "Welcome back!",
    welcomeDescription: "Here's an overview of your current activities",
    upcomingBookings: "Upcoming Appointments",
    noBookings: "No upcoming appointments",
    activeMemberships: "Active Memberships",
    noMemberships: "No active memberships",
    recentPurchases: "Recent Purchases",
    noPurchases: "No previous purchases",
    loyaltyPoints: "Loyalty Points",
    viewAll: "View All",
    bookNow: "Book Now",
    points: "points",
    validUntil: "Valid until",
    nextEvent: "Next Event",
  },
  booking: {
    title: "Book Appointment",
    selectService: "Select a service",
    selectDate: "Select a date",
    selectTime: "Select a time",
    availableSlots: "Available time slots",
    noSlots: "No available time slots for this day",
    bookButton: "Book",
    confirmBooking: "Confirm Booking",
    bookingSuccess: "Booking Successful!",
    bookingSuccessDescription: "Your appointment has been successfully booked.",
    duration: "Duration",
    price: "Price",
    minutes: "min",
    myBookings: "My Bookings",
    upcoming: "Upcoming",
    past: "Past",
    cancel: "Cancel",
    reschedule: "Reschedule",
    status: {
      confirmed: "Confirmed",
      pending: "Pending",
      cancelled: "Cancelled",
      completed: "Completed",
    },
  },
  services: {
    title: "Services",
    categories: "Categories",
    all: "All",
    popular: "Popular",
    new: "New",
    details: "Details",
    bookService: "Book Service",
    buyNow: "Buy Now",
    addToCart: "Add to Cart",
    from: "from",
    reviews: "reviews",
    duration: "Duration",
    included: "Included",
  },
  workshops: {
    title: "Workshops",
    upcoming: "Upcoming Workshops",
    past: "Past Workshops",
    registered: "Registered",
    spotsLeft: "spots left",
    full: "Full",
    register: "Register",
    unregister: "Unregister",
    date: "Date",
    location: "Location",
    online: "Online",
    inPerson: "In Person",
    participants: "participants",
    maxParticipants: "max. participants",
    price: "Price",
    free: "Free",
    description: "Description",
    materials: "Materials",
  },
  digitalContent: {
    title: "Digital Content",
    purchased: "Purchased",
    available: "Available",
    download: "Download",
    preview: "Preview",
    buy: "Buy",
    categories: {
      ebook: "E-book",
      video: "Video Course",
      audio: "Audio",
      template: "Template",
      guide: "Guide",
    },
    format: "Format",
    size: "Size",
    purchaseDate: "Purchase Date",
  },
  memberships: {
    title: "My Memberships",
    active: "Active",
    expired: "Expired",
    renew: "Renew",
    cancel: "Cancel",
    upgrade: "Upgrade",
    validFrom: "Valid from",
    validUntil: "Valid until",
    remainingUses: "Remaining uses",
    unlimited: "Unlimited",
    autoRenewal: "Auto-renewal",
    history: "Membership History",
    benefits: "Benefits",
    currentPlan: "Current Plan",
  },
  messages: {
    title: "Messages",
    newMessage: "New Message",
    sendMessage: "Send",
    placeholder: "Type your message...",
    noMessages: "No messages",
    sent: "Sent",
    received: "Received",
    read: "Read",
    unread: "Unread",
    attachFile: "Attach File",
    responseTime: "Average response time",
    hours: "hours",
  },
  loyalty: {
    title: "Loyalty Rewards",
    currentPoints: "Current Points",
    totalEarned: "Total Earned",
    level: "Level",
    nextLevel: "Next Level",
    pointsToNext: "points to next level",
    rewards: "Redeemable Rewards",
    history: "Points History",
    earned: "Earned",
    redeemed: "Redeemed",
    redeem: "Redeem",
    levels: {
      bronze: "Bronze",
      silver: "Silver",
      gold: "Gold",
      platinum: "Platinum",
    },
  },
  settings: {
    title: "Settings",
    profile: {
      title: "Profile Settings",
      name: "Name",
      email: "Email",
      phone: "Phone",
      save: "Save",
      avatar: "Profile Picture",
      changeAvatar: "Change Picture",
    },
    notifications: {
      title: "Notification Settings",
      email: "Email notifications",
      push: "Push notifications",
      sms: "SMS notifications",
      bookingReminder: "Booking reminder",
      workshopReminder: "Workshop reminder",
      promotions: "Promotions and offers",
      newsletter: "Newsletter",
    },
    privacy: {
      title: "Privacy",
      deleteAccount: "Delete Account",
      exportData: "Export Data",
    },
  },
  progress: {
    title: "My Progress",
    description: "Track your progress and reach new goals",
    stats: {
      totalSessions: "Total Sessions",
      activeGoals: "Active Goals",
      currentStreak: "Current Streak",
      completionRate: "Completion Rate",
      days: "days",
      sessions: "sessions",
    },
    goals: {
      title: "Your Goals",
      addGoal: "Add New Goal",
      progress: "Progress",
      completed: "Completed",
      inProgress: "In Progress",
      notStarted: "Not Started",
      markComplete: "Mark Complete",
      deleteGoal: "Delete Goal",
      goalName: "Goal Name",
      targetValue: "Target Value",
      currentValue: "Current Value",
      deadline: "Deadline",
      category: "Category",
      categories: {
        fitness: "Fitness",
        coaching: "Coaching",
        beauty: "Beauty",
        education: "Education",
        wellness: "Wellness",
        other: "Other",
      },
    },
    metrics: {
      title: "Metrics",
      weight: "Weight",
      performance: "Performance",
      skinHealth: "Skin Health",
      energy: "Energy Level",
      satisfaction: "Satisfaction",
      unit: "unit",
      trend: "Trend",
      improving: "Improving",
      declining: "Declining",
      stable: "Stable",
    },
    milestones: {
      title: "Milestones",
      achieved: "Achieved",
      locked: "Locked",
      progress: "Progress",
    },
    timeline: {
      title: "Activities",
      today: "Today",
      thisWeek: "This Week",
      thisMonth: "This Month",
      earlier: "Earlier",
      types: {
        booking: "Booking",
        purchase: "Purchase",
        workshop: "Workshop",
        goalCompleted: "Goal Completed",
        milestoneReached: "Milestone Reached",
        sessionCompleted: "Session Completed",
      },
    },
  },
  common: {
    loading: "Loading...",
    error: "An error occurred",
    retry: "Retry",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    currency: "HUF",
    noData: "No data",
  },
};
